module.exports = __webpack_public_path__ + "static/home-renovations-e86fd282d18cc632d1e90d19d6d6ff97.png";